import React, { useState, useEffect } from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import DataTable from "react-data-table-component";
import { BaseUrl } from "../common/config";
import Sidebar from "../common/sidebar";
import Popup from "../common/popup";
import { http } from "../helper";
import { canAction } from "../common/permissionhelper";
import { useTranslation } from "react-i18next";

const Ingredients = () => {
  const { t } = useTranslation();
  const [searchTextVal, setSearchTextVal] = useState("");
  const [ingredientslist, setIngredientslist] = useState([]);
  const [templist, setTemplist] = useState([]);
  const [loading, setLoading] = useState(true);
  const [ingredientsvalue, setIngredientsvalue] = useState("");
  const [visibleAlert, setVisibleAlert] = useState(false);

  useEffect(() => {
    if (!sessionStorage.getItem("isLoggedIn")) {
      window.location.href = "/";
      return;
    }
    const authData = JSON.parse(sessionStorage.getItem("authData"));
    if (
      authData !== "" &&
      !authData.adminRole.permissions.includes("manage_settings")
    ) {
      window.location.href = "/unauthorized";
      return;
    }
    getIngredientslist();
  }, []);

  const getIngredientslist = () => {
    let URL = BaseUrl + "admin/ingredientlist";
    http
      .get(URL)
      .then((response) => {
        const sortedData = response.data.data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
        );
        setIngredientslist(sortedData);
        setTemplist(response.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const editIngredients = (ingredient) => {
    window.location.href = `/ingredients/edit/${ingredient._id}`;
  };

  const deleteIngredients = (value) => {
    setVisibleAlert(true);
    setIngredientsvalue(value);
  };

  const deleteIngredientsvalue = () => {
    let URL = BaseUrl + `admin/ingredient/${ingredientsvalue._id}`;
    http
      .delete(URL)
      .then((response) => {
        if (response.data.success === true) {
          window.location.reload();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const alertPopupclose = () => {
    setVisibleAlert(false);
    setIngredientsvalue("");
  };

  const addIngredients = () => {
    window.location.href = "/ingredients/add/";
  };

  const handleReset = () => {
    setSearchTextVal("");
    setIngredientslist(templist);
  };

  const handleChange = (value) => {
    setSearchTextVal(value);
    filterData(value);
  };

  const filterData = (value) => {
    const lowercasedValue = value.toLowerCase().trim();
    if (lowercasedValue.length > 0) {
      const result = templist.filter((item) =>
        item.ingredientTitle.toString().toLowerCase().includes(lowercasedValue),
      );
      setIngredientslist(result);
    } else {
      setIngredientslist(templist);
    }
  };

  const columns = [
    {
      name: t("title_txt"),
      selector: (row) => row.ingredientTitle,
      sortable: true,
    },
    {
      name: t("actions_txt"),
      selector: (row) => {
        const canEdit = canAction("manage_settings", "edit");
        return (
          <div style={{ display: "flex" }}>
            <a
              className="button title-tooltip title-up"
              data-title={canEdit ? t("edit_txt") : t("view_txt")}
              style={{ color: "white" }}
              onClick={() => editIngredients(row)}
            >
              <i
                className={`fa ${canEdit ? "fa-pencil" : "fa-eye"}`}
                aria-hidden="true"
              ></i>
            </a>
            {canAction("manage_settings", "delete") && (
              <a
                className="button title-tooltip title-up"
                data-title={t("delete_txt")}
                style={{ color: "white" }}
                onClick={() => deleteIngredients(row)}
              >
                <i className="fa fa-trash" aria-hidden="true"></i>
              </a>
            )}
          </div>
        );
      },
      sortable: false,
    },
  ];

  const customStyles = {
    rows: {
      style: {
        minHeight: "25px",
      },
    },
    headCells: {
      style: {
        padding: "8px",
      },
    },
    cells: {
      style: {
        padding: "8px",
      },
    },
  };

  const paginationComponentOptions = {
    rowsPerPageText: "",
    rangeSeparatorText: "",
    selectAllRowsItem: true,
    selectAllRowsItemText: "",
    noRowsPerPage: "",
  };

  return (
    <>
      <div className="dashboard-block">
        <Sidebar />
        <div className="dash-left">
          <Header />
          <section className="cart-block">
            <div className="container">
              <h1 className="checkout-title">{t("ingredient_txt")}</h1>
              <div className="right-table-outer-wrap">
                <div className="table-filter search-orders">
                  <div className="table-search-reset">
                    <div className="table-search">
                      <input
                        type="text"
                        value={searchTextVal}
                        onChange={(e) => handleChange(e.target.value)}
                        className="form-control"
                        placeholder={t("search_txt")}
                      />
                    </div>
                    <button
                      className="submitbtn button search-ord-btn"
                      onClick={() => filterData(searchTextVal)}
                    >
                      <i className="fa fa-search"></i>
                    </button>
                    <button
                      className="resetbtn"
                      type="reset"
                      onClick={handleReset}
                    >
                      {t("reset_txt")}
                    </button>
                  </div>
                  {canAction("manage_settings", "add") && (
                    <div className="add-ingredientbtn">
                      <button className="addbtn" onClick={addIngredients}>
                        {t("add_txt")}
                      </button>
                    </div>
                  )}
                </div>
                <div className="table_overflow">
                  <DataTable
                    columns={columns}
                    noDataComponent={
                      <div className="no-records-found">
                        {t("no_matching_ingredient_txt")}
                      </div>
                    }
                    data={ingredientslist}
                    customStyles={customStyles}
                    pagination
                    paginationPerPage={25}
                    progressPending={loading}
                    paginationRowsPerPageOptions={[25, 50, 75, 100]}
                    paginationComponentOptions={paginationComponentOptions}
                  />
                </div>
              </div>
            </div>
          </section>
          <Footer />
        </div>
      </div>
      {visibleAlert && (
        <div className="custom-alert-pop paylater-popup">
          <div className="custom-alert-container">
            <div className="custom-alert-wrap">
              <div className="custom-alert-header">
                <h4>{t("alert_txt")}</h4>
              </div>
              <div className="custom-alert-body">
                <p>{t("confirm_delete_txt")}</p>
                <div className="alert-buttons">
                  <a
                    title={t("ok_txt")}
                    onClick={deleteIngredientsvalue}
                    className="popup-alert-btn button"
                  >
                    {t("ok_txt")}
                  </a>
                  <a
                    title={t("cancel_txt")}
                    onClick={alertPopupclose}
                    className="popup-alert-btn button"
                  >
                    {t("cancel_txt")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Ingredients;
